/**
 * Convierte `detail` de FastAPI/axios en texto seguro para UI (toast, setError, JSX).
 * Evita React error #31 cuando detail es un objeto.
 */
export function formatApiError(detail, fallback = 'No se pudo completar la operación') {
  if (detail == null || detail === '') return fallback;
  if (typeof detail === 'string' || typeof detail === 'number' || typeof detail === 'boolean') {
    return String(detail);
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') return d.msg || d.message || formatApiError(d, '');
        return '';
      })
      .filter(Boolean);
    return parts.join('. ') || fallback;
  }
  if (typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
    if (typeof detail.detail === 'string' && detail.detail.trim()) return detail.detail;
    if (typeof detail.msg === 'string' && detail.msg.trim()) return detail.msg;
    if (typeof detail.error === 'string' && detail.error.trim()) return detail.error;
    if (detail.error != null) return formatApiError(detail.error, fallback);
    try {
      return JSON.stringify(detail);
    } catch {
      return fallback;
    }
  }
  return fallback;
}

export function formatAxiosError(err, fallback = 'No se pudo completar la operación') {
  return formatApiError(err?.response?.data?.detail ?? err?.message, fallback);
}
